import {
  Box,
  Button as MuiButton,
  Grid,
  Link,
  Stack,
  Typography,
} from "@mui/material";

import { PagePaper, SectionPaper } from "../../components/Paper";
import { PageTitle } from "../../components/Title";
import { AcquiredBookList } from "./components/AcquiredBookList";
import AddIcon from "@mui/icons-material/Add";
import { RequestFeedGrid } from "./components/RequestFeedGrid";
import { KeyboardArrowLeft } from "@mui/icons-material";
import TopicIcon from "@mui/icons-material/Topic";
import React, { useEffect, useState } from "react";
import { useFeatureFlags } from "@/configs/featureFlag";
import { ExecuteModal } from "@/features/monitoring/components/ExecuteModal";
import { type GridRowId } from "@mui/x-data-grid-pro";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import Tooltip from "@mui/material/Tooltip";
import { Link as RouterLink } from "react-router-dom";
import { RegistryChangeAlertSummarySection } from "@/features/registryChangeAlert";

export const AcquireBookListPresenter: React.FC = () => {
  const {
    mypageTop,
    realEstateRegistrationMonitoring,
    propertySummary,
    acquiredRealEstateSearch,
    registryChangeAlert,
  } = useFeatureFlags();
  const isAcquiredSearchEnabled = acquiredRealEstateSearch === true;

  const [
    openMonitoringExecuteConfirmDialog,
    setOpenMonitoringExecuteConfirmDialog,
  ] = useState<boolean>(false);
  const [selectedId, setSelectedId] = useState<GridRowId>("");
  const [chargeCount, setChargeCount] = useState<number | null>(null);
  const isRequestList = !isAcquiredSearchEnabled;
  useEffect(() => {
    setOpenMonitoringExecuteConfirmDialog(false);
  }, [isRequestList]);

  return (
    <PagePaper>
      <Box>
        {isAcquiredSearchEnabled ? (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: 2,
              mb: 3,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <TopicIcon sx={{ mr: 1 }} fontSize="large" />
              <PageTitle>取得済不動産登記を検索する</PageTitle>
            </Box>
            <Stack
              direction="row"
              spacing={2}
              flexWrap="wrap"
              useFlexGap
              alignItems="center"
            >
              {propertySummary && (
                <Link
                  component={RouterLink}
                  to="/propertysummary"
                  sx={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  <NewspaperIcon fontSize="small" />
                  物件概要書 (α版)
                </Link>
              )}
              <Link
                component={RouterLink}
                to="/acquirebook"
                sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
              >
                <AddIcon fontSize="small" />
                地番・家屋番号から不動産登記簿を取得する
              </Link>
              <Link
                component={RouterLink}
                to="/acquiremultiplebooks/upload"
                sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
              >
                <AddIcon fontSize="small" />
                地番・家屋番号リストから不動産登記簿を取得する
              </Link>
            </Stack>
          </Box>
        ) : (
          <>
            <Box sx={{ display: "flex" }}>
              {/* ページタイトル */}
              <Box
                sx={{
                  display: "flex",
                  mb: 3,
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: 2,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <TopicIcon sx={{ mr: 1 }} fontSize="large" />
                  <PageTitle>登記取得依頼一覧</PageTitle>
                </Box>
              </Box>
            </Box>
            <Grid container spacing={2}>
              {propertySummary && (
                <Grid item xs>
                  <Stack my={2} direction="row" spacing={1} alignItems="center">
                    <Tooltip
                      title={"作成した物件概要書の一覧を確認できます"}
                      placement="top"
                      arrow
                    >
                      <MuiButton
                        variant="outlined"
                        color="brand"
                        size="medium"
                        component={RouterLink}
                        to={"/propertysummary"}
                        sx={{
                          textAlign: "center",
                          fontWeight: "bold",
                          borderRadius: "3px",
                          textTransform: "none",
                          minHeight: "48px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <NewspaperIcon sx={{ mr: 1, fontSize: "20px" }} />
                        物件概要書
                        <Typography
                          component={"span"}
                          sx={{
                            textTransform: "none",
                            fontWeight: 400,
                            fontSize: "0.85em",
                            marginLeft: 0.5,
                            opacity: 0.8,
                          }}
                        >
                          (α版)
                        </Typography>
                      </MuiButton>
                    </Tooltip>
                  </Stack>
                </Grid>
              )}
              <Grid item xs>
                <Stack
                  my={2}
                  direction="row"
                  justifyContent="end"
                  spacing={1}
                  alignItems="center"
                >
                  <MuiButton
                    variant="outlined"
                    size="medium"
                    component={RouterLink}
                    to={"/acquirebook"}
                    sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                      minHeight: "48px",
                    }}
                  >
                    地番・家屋番号から
                    <br />
                    不動産登記簿を取得する
                  </MuiButton>
                  <MuiButton
                    variant="outlined"
                    component={RouterLink}
                    to={"/acquiremultiplebooks/upload"}
                    sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                      minHeight: "48px",
                    }}
                  >
                    地番・家屋番号リストから
                    <br />
                    不動産登記簿を取得する
                  </MuiButton>
                </Stack>
              </Grid>
            </Grid>
          </>
        )}
        <Box sx={{ mb: 2 }}>
          <RegistryChangeAlertSummarySection
            enabled={registryChangeAlert === true}
          />
        </Box>
        {isRequestList ? (
          <SectionPaper>
            <RequestFeedGrid
              setSelectedId={setSelectedId}
              setOpenMonitoringExecuteConfirmDialog={
                setOpenMonitoringExecuteConfirmDialog
              }
              setChargeCountClickedMonitoringExecuteButton={setChargeCount}
            />
          </SectionPaper>
        ) : (
          <AcquiredBookList />
        )}

        {/* 戻る */}
        <Box sx={{ mt: 2 }}>
          <Link
            component={RouterLink}
            to={mypageTop ? "/mypage" : "/feed"}
            sx={{ display: "inline-block" }}
          >
            <Box sx={{ display: "flex" }}>
              <KeyboardArrowLeft />
              <Typography>
                {mypageTop ? "マイページに戻る" : "不動産の権利異動検索に戻る"}
              </Typography>
            </Box>
          </Link>
        </Box>
      </Box>
      {isRequestList &&
        realEstateRegistrationMonitoring &&
        chargeCount !== null &&
        chargeCount > 0 && (
          <ExecuteModal
            open={openMonitoringExecuteConfirmDialog}
            setOpen={setOpenMonitoringExecuteConfirmDialog}
            chargeCount={chargeCount}
            pictureRequestId={Number(selectedId)}
          />
        )}
    </PagePaper>
  );
};
